import { Box, Paper, Tab } from "@mui/material";
import { useEffect, useState } from "react";
import Base from "../../../Base/views/Base"
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import PendingApprovalPage from "./PendingApprovalPage";
import ArrowBackButton from "../../../Base/views/ArrowBackButton";
import history from "../../../../../history";
import MyReporteesLandingPage from "./MyReportees/MyReporteesLandingPage";
import { useDispatch } from "react-redux";
import { GetAccessWorkLocationAction } from "../../../../../store/Ancillary/WorkLocation/Action";


const ManagerViewEcmsLandingPage = () => {
    const [value, setValue] = useState(0);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(GetAccessWorkLocationAction());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Base>
            <Box sx={{ minHeight: "calc(100vh - 65px)",
                        maxHeight: "calc(100vh - 65px)", overflowY: 'auto' }}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <ArrowBackButton
                        iconSize={18}
                        onClick={() => history.push("/exit-management")}
                    />
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    sx={{
                        minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                        '& .MuiTabs-indicator': {
                            width: '100%',
                            display: 'flex',
                            justifyContent: "center !important",
                        },
                        mb: 1
                    }}
                    >
                    <Tab label="My Reportees" {...a11yProps(0)} />
                    <Tab label="Pending Approval" {...a11yProps(1)} />
                </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <MyReporteesLandingPage />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <PendingApprovalPage />
                </TabPanel>
            </Box>
        </Base>
    )
}
export default ManagerViewEcmsLandingPage;
